import { render } from "./YuklamaVaTaqsimot.vue?vue&type=template&id=11eac010&scoped=true"
import script from "./YuklamaVaTaqsimot.vue?vue&type=script&lang=js"
export * from "./YuklamaVaTaqsimot.vue?vue&type=script&lang=js"

import "./YuklamaVaTaqsimot.vue?vue&type=style&index=0&id=11eac010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11eac010"]])

export default __exports__